import {Link} from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import * as style from "../components/css/header.module.css"
import logo from "../images/kfm-company-logo.svg"

const Header = ({ siteTitle }) => (
  <header id="global-navigation" className={`${style.globalNav}`}>
    <div className={`${style.globalNavFrame}`}>
      <figure className={`${style.menuListBtn} menu-list-btn forSP`}>
          <div className={`menu-trigger`}>
              <span></span>
              <span></span>
              <span></span>
          </div>
      </figure>

      <a href="/" className={`${style.companyLogoFrame} company-logo-frame`} >
        <img src={`${logo}`} className={`${style.companyLogo} company-logo`} alt="柏魚市場株式会社　ロゴ" />
      </a>
      <nav className={`${style.navigationFrame} navigation-frame`}>
        <ul className={`${style.menuList} menu-list`} itemScope itemType="http://www.schema.org/SiteNavigationElement">
          <li className={`${style.menuItem} menu-item`} itemProp="name">
            <a href="/wholesale-price" itemProp="url">本日の卸売価格</a>
          </li>
          <li className={`${style.menuItem} menu-item`} itemProp="name">
            <Link to={`/news-room`} itemProp="url">ニュース・話題</Link>
          </li>
          <li className={`${style.menuItem} menu-item`} itemProp="name">
            <Link to={`/market`} itemProp="url">柏魚市場で仕入れよう</Link>
          </li>
          {/* <li className={`${style.menuItem} menu-item`} itemProp="name">
            <a href="/our-mission" itemProp="url">魚のためにできること</a>
          </li> */}
          <li className={`${style.menuItem} menu-item`} itemProp="name">
            <Link to={`/about-us`} itemProp="url">ごあいさつ</Link>
          </li>
          <li className={`${style.menuItem} menu-item`} itemProp="name">
          <Link to={`/smart-fish-market`} itemProp="url">スマート魚市場</Link>
          </li>
        </ul>
      </nav>
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
